/**
 * Text Accordion Component JavaScript
 * Handles Bootstrap accordion functionality - CSS handles icon animations
 */

var textAccordion = {
    /**
     * Initialize accordion functionality
     */
    init: function () {
        this.setupAccordionToggle();
    },

    /**
     * Setup accordion toggle functionality
     */
    setupAccordionToggle: function () {
        $(document).on('click', '.text-accordion .accordion-toggle', function () {
            var $button = $(this);
            var targetId = $button.attr('data-target');
            var $target = $(targetId);

            // Toggle collapse with Bootstrap
            $target.collapse('toggle');

            // Update aria-expanded attribute for CSS styling
            $target.on('show.bs.collapse', function () {
                $button.attr('aria-expanded', 'true');
            });

            $target.on('hide.bs.collapse', function () {
                $button.attr('aria-expanded', 'false');
            });
        });
    }
};

// Export initialization function for SFRA processInclude pattern
module.exports = function () {
    textAccordion.init();
    return textAccordion;
}; 